export function buildQuotePostIntentUrl(text, tweetUrl) {
  const intentText = `${text.trim()} ${tweetUrl}`;

  return `https://x.com/intent/post?text=${encodeURIComponent(intentText)}`;
}
